import { useTranslation } from "react-i18next";

import { IoLogoYoutube } from "react-icons/io";
import { BsFacebook, BsLinkedin, BsInstagram } from "react-icons/bs";
import DarklogoImage from "../../components/navigation/d.png";
import logoImage from "../../components/navigation/b.png";
const Footer = ({ theme }) => {
  const { t } = useTranslation();

  return (
    <div className="   text-white">
      <div>
        <div></div>

        <div className="pt-10  ">
          <div className="flex justify-between pt-2 pb-3 mt-80 mx-5 y9:mx-16  font-semibold dark:text-[#787f98] text-slate-800 border-t border-[#787f98] ">
            <div>
              <div className="mb-4">
                <img
                  className="w-[130px]"
                  src={theme === "lightTheme" ? logoImage : DarklogoImage}
                  alt=""
                />{" "}
              </div>
              <div className="text-sm y9:text-[15px]">
                <span>
                  If you want a store that is full of various books at the best
                  price, you have come to the right place
                </span>
              </div>
            </div>

            <div className="flex text-sm  ">
              <div className="mx-7  cursor-pointer">{t("about")} </div>
              <div className=" cursor-pointer">{t("blog")} </div>
            </div>

            <div className="mx-5 ">
              <div className="text-[20px] y9:text-[23px] mb-2 cursor-pointer ">
                {" "}
                <IoLogoYoutube />{" "}
              </div>
              <div className="text-[20px] y9:text-[23px] mb-2 cursor-pointer">
                {" "}
                <BsFacebook />{" "}
              </div>
              <div className="text-[20px] y9:text-[23px] mb-2 cursor-pointer">
                {" "}
                <BsLinkedin />{" "}
              </div>
              <div className="text-[20px] y9:text-[23px] mb-2 cursor-pointer">
                <BsInstagram />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
